import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.settings');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as SettingsForms from './form-state';
import * as SettingsView from './view-utils';

@Component({
    selector: 'wiz-page-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.settings/view.scss */
:host {
  display: block;
}

.hn-settings-page {
  max-width: 1100px;
  padding-bottom: 28px;
}

.hn-settings-head {
  align-items: center;
}

.hn-settings-target {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 13px;
  color: var(--hn-ink);
  display: grid;
  gap: 10px;
  grid-template-columns: 30px minmax(0, 1fr) 10px;
  min-height: 44px;
  padding: 6px 11px 6px 7px;
  text-decoration: none;
  transition: border-color 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
}

.hn-settings-target:hover {
  border-color: var(--hn-muted);
  transform: translateY(-1px);
}

.hn-settings-target > i:first-child {
  align-items: center;
  background: var(--hn-accent-soft);
  border-radius: 8px;
  color: var(--hn-accent-deep);
  display: flex;
  height: 30px;
  justify-content: center;
}

.hn-settings-target > i:last-child {
  color: var(--hn-line-strong);
  font-size: 11px;
}

.hn-settings-target small,
.hn-settings-target strong {
  display: block;
}

.hn-settings-target small {
  color: var(--hn-muted);
  font-size: 13px;
  line-height: 1;
}

.hn-settings-target strong {
  font-size: 15px;
  font-weight: 800;
  margin-top: 4px;
  max-width: 154px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-settings-target.is-empty > i:first-child {
  background: var(--hn-paper-muted);
  color: var(--hn-muted);
}

.hn-settings-tabs {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 11px;
  display: inline-flex;
  gap: 4px;
  margin-top: 10px;
  padding: 3px;
  position: sticky;
  top: 8px;
  z-index: 8;
}

.hn-settings-tabs a {
  align-items: center;
  border-radius: 8px;
  color: var(--hn-muted-strong);
  display: grid;
  font-size: 15px;
  font-weight: 700;
  gap: 8px;
  grid-template-columns: 15px auto auto;
  min-height: 38px;
  padding: 0 12px;
  text-decoration: none;
  transition: background-color 0.16s var(--hn-ease), color 0.16s var(--hn-ease), box-shadow 0.16s var(--hn-ease);
}

.hn-settings-tabs a:hover,
.hn-settings-tabs a:focus-visible {
  background: var(--hn-paper-muted);
  color: var(--hn-ink);
}

.hn-settings-tabs a.is-active {
  background: var(--hn-charcoal);
  box-shadow: 0 2px 5px rgba(18, 21, 18, 0.16);
  color: #fff;
}

.hn-settings-tabs a i {
  color: var(--hn-accent-deep);
  font-size: 13px;
}

.hn-settings-tabs a.is-active i {
  color: var(--hn-accent);
}

.hn-settings-tabs em {
  background: var(--hn-paper-muted);
  border-radius: 999px;
  color: var(--hn-muted);
  font-size: var(--hn-text-caption);
  font-style: normal;
  font-weight: 800;
  line-height: 22px;
  min-width: 36px;
  padding: 0 7px;
  text-align: center;
}

.hn-settings-tabs a.is-active em {
  background: rgba(255, 255, 255, 0.11);
  color: rgba(255, 255, 255, 0.76);
}

.hn-settings-tabs em.is-ready {
  color: var(--hn-accent-deep);
}

.hn-settings-tabs a.is-active em.is-ready {
  color: var(--hn-accent);
}

.hn-settings-main {
  display: grid;
  gap: 9px;
  margin-top: 9px;
  min-width: 0;
}

.hn-settings-panel {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: var(--hn-radius-lg);
  min-width: 0;
  overflow: hidden;
}

.hn-settings-panel[hidden] {
  display: none !important;
}

.hn-panel-head {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: flex;
  gap: 16px;
  justify-content: space-between;
  min-height: 58px;
  padding: 10px 15px;
}

.hn-panel-head h2 {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 0;
}

.hn-panel-head p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.35;
  margin: 2px 0 0;
}

.hn-status {
  align-items: center;
  background: var(--hn-warn-soft);
  border-radius: 999px;
  color: #785114;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 800;
  gap: 6px;
  min-height: 28px;
  padding: 0 9px;
}

.hn-status.is-ready {
  background: var(--hn-accent-soft);
  color: var(--hn-accent-deep);
}

.hn-status i {
  font-size: 10px;
}

.hn-connection-row {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: 34px minmax(180px, 1fr) auto auto;
  min-height: 64px;
  padding: 10px 15px;
}

.hn-connection-dot {
  align-items: center;
  background: var(--hn-warn-soft);
  border-radius: 50%;
  color: #785114;
  display: flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.hn-connection-row.is-connected .hn-connection-dot {
  background: var(--hn-accent-soft);
  color: var(--hn-accent-deep);
}

.hn-connection-row.is-failed .hn-connection-dot {
  background: var(--hn-danger-soft);
  color: var(--hn-danger);
}

.hn-connection-row.is-checking .hn-connection-dot {
  background: #eef3ff;
  color: #2359cb;
}

.hn-connection-row.is-checking .hn-connection-dot i {
  animation: hn-settings-spin 0.8s linear infinite;
}

.hn-connection-row.is-dirty .hn-connection-dot {
  background: var(--hn-paper-muted);
  color: var(--hn-muted);
}

.hn-connection-copy {
  min-width: 0;
}

.hn-connection-copy strong {
  display: block;
  font-size: 16px;
  font-weight: 820;
}

.hn-connection-copy p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.4;
  margin: 3px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-connection-meta {
  text-align: right;
}

.hn-connection-meta strong,
.hn-connection-meta small {
  display: block;
  font-variant-numeric: tabular-nums;
}

.hn-connection-meta strong {
  font-size: 13px;
  font-weight: 700;
}

.hn-connection-meta small {
  color: var(--hn-muted);
  font-size: 13px;
  margin-top: 2px;
  white-space: nowrap;
}

.hn-row-actions {
  align-items: center;
  display: flex;
  gap: 7px;
}

.hn-minute-row {
  align-items: center;
  background: var(--hn-paper-soft);
  border-top: 1px solid var(--hn-line);
  display: grid;
  gap: 8px;
  grid-template-columns: 14px auto auto minmax(80px, 1fr);
  min-height: 42px;
  padding: 7px 15px;
}

.hn-minute-row > i {
  color: var(--hn-muted);
  font-size: 13px;
}

.hn-minute-row > span {
  color: var(--hn-muted);
  font-size: 13px;
  font-weight: 700;
}

.hn-minute-row > strong {
  font-size: 14px;
  font-weight: 800;
}

.hn-minute-row > small {
  color: var(--hn-muted);
  font-size: 13px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-minute-row.is-ready > i {
  color: var(--hn-accent-deep);
}

.hn-minute-row.is-partial > i {
  color: #785114;
}

.hn-minute-row.is-running > i {
  color: #2359cb;
}

.hn-minute-row.is-failed > i {
  color: var(--hn-danger);
}

.hn-minute-row progress {
  appearance: none;
  border: 0;
  border-radius: 999px;
  grid-column: 1/-1;
  height: 3px;
  overflow: hidden;
  width: 100%;
}

.hn-minute-row progress::-webkit-progress-bar {
  background: var(--hn-line);
}

.hn-minute-row progress::-webkit-progress-value {
  background: var(--hn-accent-deep);
}

.hn-minute-row progress::-moz-progress-bar {
  background: var(--hn-accent-deep);
}

.hn-disclosure,
.hn-strategy-disclosure {
  border-top: 1px solid var(--hn-line);
}

.hn-disclosure summary,
.hn-strategy-disclosure summary {
  align-items: center;
  cursor: pointer;
  display: grid;
  gap: 10px;
  grid-template-columns: auto minmax(0, 1fr) 12px;
  list-style: none;
  min-height: 44px;
  padding: 7px 15px;
}

.hn-disclosure summary::-webkit-details-marker,
.hn-strategy-disclosure summary::-webkit-details-marker {
  display: none;
}

.hn-disclosure summary:hover,
.hn-strategy-disclosure summary:hover {
  background: var(--hn-paper-soft);
}

.hn-disclosure summary > span,
.hn-strategy-disclosure summary > span {
  font-size: 14px;
  font-weight: 800;
}

.hn-disclosure summary > small,
.hn-strategy-disclosure summary > small {
  color: var(--hn-muted);
  font-size: 13px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-disclosure summary > i,
.hn-strategy-disclosure summary > i {
  color: var(--hn-muted);
  font-size: 11px;
  transition: transform 0.16s var(--hn-ease);
}

.hn-disclosure[open] summary > i,
.hn-strategy-disclosure[open] summary > i {
  transform: rotate(180deg);
}

.hn-disclosure__body,
.hn-strategy-disclosure__body {
  border-top: 1px solid var(--hn-line);
  padding: 11px 15px 13px;
}

.hn-saved-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
}

.hn-saved-grid > div {
  border-bottom: 1px solid var(--hn-line);
  min-width: 0;
  padding: 9px 12px 9px 0;
}

.hn-saved-grid > div:not(:nth-child(3n+1)) {
  border-left: 1px solid var(--hn-line);
  padding-left: 12px;
}

.hn-saved-grid dt {
  color: var(--hn-muted);
  font-size: 13px;
}

.hn-saved-grid dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.hn-saved-grid dd.is-empty {
  color: var(--hn-muted);
  font-weight: 600;
}

.hn-danger-link,
.hn-text-button {
  background: transparent;
  border: 0;
  color: var(--hn-muted-strong);
  font-size: 14px;
  font-weight: 700;
  min-height: 38px;
  padding: 0;
}

.hn-danger-link {
  color: var(--hn-danger);
  margin-top: 8px;
}

.hn-text-button.is-danger {
  color: var(--hn-danger);
}

.hn-disconnect-form {
  align-items: end;
  background: var(--hn-danger-soft);
  border-top: 1px solid #efbeb7;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(180px, 1fr) minmax(200px, 0.8fr) auto;
  padding: 14px 18px;
}

.hn-disconnect-copy strong {
  color: var(--hn-danger);
  display: block;
  font-size: 14px;
}

.hn-disconnect-copy p {
  color: var(--hn-muted-strong);
  font-size: 13px;
  line-height: 1.4;
  margin: 3px 0 0;
}

.hn-kis-form,
.hn-budget-form {
  display: grid;
  gap: 13px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 14px 15px;
}

.hn-form-field {
  display: block;
  min-width: 0;
}

.hn-form-field--wide {
  grid-column: 1/-1;
}

.hn-form-field > span,
.hn-form-field > label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 7px;
}

.hn-form-field > span em,
.hn-form-field > label em {
  color: var(--hn-muted);
  font-size: 13px;
  font-style: normal;
  font-weight: 550;
  margin-left: 5px;
}

.hn-form-field input,
.hn-form-field select {
  background: var(--hn-paper-soft);
  border: 1px solid var(--hn-line-strong);
  border-radius: 11px;
  color: var(--hn-ink);
  font-size: 15px;
  min-height: 46px;
  padding: 0 12px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), box-shadow 0.16s var(--hn-ease);
  width: 100%;
}

.hn-form-field input::placeholder {
  color: #858c84;
  opacity: 1;
}

.hn-form-field input:focus,
.hn-form-field select:focus {
  background: #fff;
  border-color: var(--hn-accent-deep);
  box-shadow: 0 0 0 3px rgba(168, 200, 93, 0.17);
  outline: 0;
}

.hn-form-field input[aria-invalid=true],
.hn-form-field select[aria-invalid=true] {
  border-color: var(--hn-danger);
  box-shadow: 0 0 0 3px rgba(217, 76, 58, 0.1);
}

.hn-field-help,
.hn-money-preview,
.hn-field-error {
  display: block;
  font-size: 13px;
  line-height: 1.4;
  margin-top: 5px;
}

.hn-field-help {
  color: var(--hn-muted);
}

.hn-money-preview {
  color: var(--hn-accent-deep);
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.hn-field-error {
  color: var(--hn-danger);
  font-weight: 700;
}

.hn-field-support {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.hn-inline-warning {
  color: #6b4a14;
  display: block;
  font-size: 13px;
  font-weight: 700;
  margin-top: 5px;
}

.hn-number-input {
  position: relative;
}

.hn-number-input input {
  font-variant-numeric: tabular-nums;
  padding-right: 48px;
}

.hn-number-input em {
  color: var(--hn-muted);
  font-size: 13px;
  font-style: normal;
  font-weight: 650;
  position: absolute;
  right: 12px;
  top: 14px;
}

.hn-form-footer {
  align-items: center;
  border-top: 1px solid var(--hn-line);
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding-top: 14px;
}

.hn-form-footer p {
  color: var(--hn-muted);
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
}

.hn-form-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.hn-primary-button,
.hn-secondary-button,
.hn-danger-button {
  align-items: center;
  border-radius: 9px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 800;
  gap: 7px;
  justify-content: center;
  min-height: 42px;
  padding: 0 14px;
  transition: background-color 0.16s var(--hn-ease), border-color 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
}

.hn-primary-button {
  background: var(--hn-charcoal);
  border: 1px solid var(--hn-charcoal);
  color: #fff;
}

.hn-primary-button:hover:not(:disabled) {
  background: #252a25;
  transform: translateY(-1px);
}

.hn-primary-button i {
  color: var(--hn-accent);
}

.hn-secondary-button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  color: var(--hn-ink);
}

.hn-secondary-button:hover:not(:disabled) {
  background: var(--hn-paper-soft);
  border-color: var(--hn-muted);
}

.hn-danger-button {
  background: var(--hn-paper);
  border: 1px solid #e5aaa2;
  color: var(--hn-danger);
}

.hn-danger-button:hover:not(:disabled) {
  background: #fff7f5;
}

.hn-primary-button:disabled,
.hn-secondary-button:disabled,
.hn-danger-button:disabled,
.hn-danger-link:disabled {
  cursor: not-allowed;
  opacity: 0.46;
}

.hn-active-cycle {
  align-items: center;
  background: var(--hn-paper-soft);
  border-bottom: 1px solid var(--hn-line);
  display: grid;
  gap: 10px;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  min-height: 42px;
  padding: 7px 15px;
}

.hn-active-cycle > i {
  color: var(--hn-accent-deep);
  font-size: 12px;
}

.hn-active-cycle p {
  font-size: 13px;
  margin: 0;
}

.hn-active-cycle p strong {
  font-weight: 800;
}

.hn-active-cycle p span {
  color: var(--hn-muted);
  margin-left: 7px;
}

.hn-active-cycle > small {
  color: var(--hn-muted);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.hn-next-summary {
  align-items: stretch;
  border-bottom: 1px solid var(--hn-line);
  display: grid;
  grid-template-columns: minmax(170px, 0.8fr) minmax(0, 2fr);
  padding: 10px 15px;
}

.hn-next-summary__title {
  align-self: center;
  min-width: 0;
  padding-right: 14px;
}

.hn-next-summary__title small,
.hn-next-summary__title strong {
  display: block;
}

.hn-next-summary__title small {
  color: var(--hn-muted);
  font-size: 13px;
  font-weight: 700;
}

.hn-next-summary__title strong {
  font-size: 17px;
  font-weight: 800;
  margin-top: 3px;
  overflow-wrap: anywhere;
}

.hn-next-summary dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
}

.hn-next-summary dl > div {
  border-left: 1px solid var(--hn-line);
  min-width: 0;
  padding: 5px 12px;
}

.hn-next-summary dt {
  color: var(--hn-muted);
  font-size: 13px;
}

.hn-next-summary dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.hn-budget-mode {
  border: 0;
  margin: 0;
  padding: 0;
}

.hn-budget-mode legend {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 7px;
}

.hn-budget-mode__options {
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr 1fr;
}

.hn-budget-mode__options label {
  align-items: center;
  border: 1px solid var(--hn-line-strong);
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  min-height: 58px;
  padding: 8px 12px;
}

.hn-budget-mode__options label.is-selected {
  background: var(--hn-accent-soft);
  border-color: #aec56f;
}

.hn-budget-mode__options input {
  accent-color: var(--hn-accent-deep);
  flex: 0 0 17px;
  height: 17px;
  min-height: 17px;
  padding: 0;
  width: 17px;
}

.hn-budget-mode__options strong {
  display: block;
  font-size: 14px;
}

.hn-budget-mode__options small {
  color: var(--hn-muted);
  display: block;
  font-size: 13px;
  margin-top: 2px;
}

.hn-control-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.hn-approval-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
}

.hn-risk-note {
  align-items: flex-start;
  color: var(--hn-muted-strong);
  display: flex;
  gap: 8px;
}

.hn-risk-note i {
  color: #8b601b;
  font-size: 12px;
  margin-top: 2px;
}

.hn-risk-note p {
  font-size: 13px;
  line-height: 1.45;
  margin: 0;
}

.hn-risk-note strong {
  color: var(--hn-ink);
}

.hn-account-check {
  align-items: center;
  background: var(--hn-paper-soft);
  border-top: 1px solid var(--hn-line);
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(155px, 0.7fr) minmax(250px, 1.3fr) auto;
  padding: 10px 15px;
}

.hn-account-check__copy strong {
  display: block;
  font-size: 14px;
  font-weight: 800;
}

.hn-account-check__copy p {
  color: var(--hn-muted);
  font-size: 13px;
  line-height: 1.35;
  margin: 3px 0 0;
}

.hn-account-check__copy p.is-blocked {
  color: var(--hn-danger);
  font-weight: 700;
}

.hn-readiness-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-end;
}

.hn-readiness-list span,
.hn-readiness-list a {
  align-items: center;
  color: var(--hn-danger);
  display: inline-flex;
  font-size: 13px;
  font-weight: 700;
  gap: 4px;
  min-height: 28px;
  padding: 0 5px;
  text-decoration: none;
}

.hn-readiness-list span.is-ready {
  color: var(--hn-accent-deep);
}

.hn-readiness-list a:hover {
  text-decoration: underline;
}

.hn-strategy-note {
  background: var(--hn-accent-soft);
  border-radius: 8px;
  color: var(--hn-accent-deep);
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 8px;
  padding: 8px 10px;
}

.hn-strategy-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.hn-strategy-grid > div {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: flex;
  gap: 16px;
  justify-content: space-between;
  min-height: 40px;
}

.hn-strategy-grid > div:nth-child(odd) {
  padding-right: 18px;
}

.hn-strategy-grid > div:nth-child(even) {
  border-left: 1px solid var(--hn-line);
  padding-left: 18px;
}

.hn-strategy-grid dt {
  color: var(--hn-muted);
  font-size: 13px;
}

.hn-strategy-grid dd {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin: 0;
  text-align: right;
}

.hn-strategy-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 10px;
}

.hn-strategy-meta span {
  color: var(--hn-muted);
  font-size: 13px;
  font-weight: 650;
}

.hn-settings-notice,
.hn-settings-feedback {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 11px;
  display: flex;
  gap: 10px;
  min-height: 48px;
  padding: 9px 12px;
}

.hn-settings-notice {
  background: var(--hn-accent-soft);
  border-color: #d6e7b7;
}

.hn-settings-notice i {
  color: var(--hn-accent-deep);
}

.hn-settings-notice p,
.hn-settings-feedback strong {
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}

.hn-settings-notice.is-error {
  background: var(--hn-danger-soft);
  border-color: #efbeb7;
}

.hn-settings-notice.is-error i {
  color: var(--hn-danger);
}

.hn-settings-feedback {
  margin-top: 9px;
}

.hn-settings-feedback > span {
  animation: hn-settings-pulse 0.8s ease-in-out infinite alternate;
  background: var(--hn-accent);
  border-radius: 50%;
  height: 9px;
  width: 9px;
}

.hn-settings-feedback.is-error {
  justify-content: space-between;
}

.hn-settings-feedback.is-error strong {
  color: var(--hn-danger);
}

.hn-settings-feedback.is-error p {
  color: var(--hn-muted);
  font-size: 13px;
  margin: 2px 0 0;
}

.hn-settings-feedback button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  min-height: 40px;
  padding: 0 12px;
}

@keyframes hn-settings-pulse {
  to {
    opacity: 0.3;
    transform: scale(0.8);
  }
}
@keyframes hn-settings-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 780px) {
  .hn-connection-row {
    grid-template-columns: 34px minmax(0, 1fr) auto;
  }
  .hn-connection-meta {
    display: none;
  }
  .hn-disconnect-form {
    grid-template-columns: 1fr 1fr;
  }
  .hn-disconnect-copy {
    grid-column: 1/-1;
  }
  .hn-account-check {
    grid-template-columns: minmax(150px, 1fr) auto;
  }
  .hn-readiness-list {
    grid-column: 1/-1;
    justify-content: flex-start;
    order: 3;
  }
}
@media (max-width: 620px) {
  .hn-settings-page {
    padding-bottom: 18px;
  }
  .hn-settings-target strong {
    max-width: 116px;
  }
  .hn-settings-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 9px;
    top: 6px;
    width: 100%;
  }
  .hn-settings-tabs a {
    grid-template-columns: 14px minmax(0, 1fr) auto;
    justify-content: center;
    padding: 0 9px;
  }
  .hn-settings-main {
    margin-top: 8px;
  }
  .hn-panel-head {
    min-height: 56px;
    padding: 9px 12px;
  }
  .hn-panel-head h2 {
    font-size: 17px;
  }
  .hn-panel-head p {
    font-size: var(--hn-text-body);
  }
  .hn-connection-row {
    align-items: start;
    grid-template-columns: 34px minmax(0, 1fr);
    padding: 10px 12px;
  }
  .hn-connection-dot {
    margin-top: 2px;
  }
  .hn-row-actions {
    grid-column: 1/-1;
  }
  .hn-row-actions > button {
    flex: 1;
  }
  .hn-minute-row {
    grid-template-columns: 13px auto minmax(0, 1fr);
    padding: 8px 14px;
  }
  .hn-minute-row > strong {
    text-align: right;
  }
  .hn-minute-row > small {
    display: none;
  }
  .hn-disclosure summary,
  .hn-strategy-disclosure summary {
    padding: 8px 14px;
  }
  .hn-disclosure summary > small,
  .hn-strategy-disclosure summary > small {
    max-width: 160px;
  }
  .hn-disclosure__body,
  .hn-strategy-disclosure__body {
    padding: 12px 14px 14px;
  }
  .hn-saved-grid {
    grid-template-columns: 1fr;
  }
  .hn-saved-grid > div:not(:nth-child(3n+1)) {
    border-left: 0;
    padding-left: 0;
  }
  .hn-kis-form,
  .hn-budget-form {
    grid-template-columns: 1fr;
    padding: 12px;
  }
  .hn-form-field--wide {
    grid-column: auto;
  }
  .hn-form-field input,
  .hn-form-field select {
    font-size: 16px;
    min-height: 46px;
  }
  .hn-number-input em {
    top: 15px;
  }
  .hn-control-grid,
  .hn-approval-grid {
    grid-template-columns: 1fr;
  }
  .hn-form-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .hn-form-footer p:empty {
    display: none;
  }
  .hn-form-actions {
    justify-content: flex-end;
  }
  .hn-primary-button,
  .hn-secondary-button,
  .hn-danger-button {
    min-height: 44px;
  }
  .hn-active-cycle {
    align-items: start;
    grid-template-columns: 16px minmax(0, 1fr);
    padding: 9px 14px;
  }
  .hn-active-cycle p span {
    display: block;
    margin: 3px 0 0;
  }
  .hn-active-cycle > small {
    grid-column: 2;
  }
  .hn-next-summary {
    grid-template-columns: 1fr;
    padding: 11px 14px;
  }
  .hn-next-summary__title {
    padding: 0 0 9px;
  }
  .hn-next-summary dl > div:first-child {
    border-left: 0;
    padding-left: 0;
  }
  .hn-next-summary dl > div {
    padding: 3px 9px;
  }
  .hn-account-check {
    grid-template-columns: minmax(0, 1fr) auto;
    padding: 11px 14px;
  }
  .hn-readiness-list {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 2px;
  }
  .hn-readiness-list span,
  .hn-readiness-list a {
    flex: 0 0 auto;
  }
  .hn-strategy-grid {
    grid-template-columns: 1fr;
  }
  .hn-strategy-grid > div:nth-child(odd),
  .hn-strategy-grid > div:nth-child(even) {
    border-left: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .hn-disconnect-form {
    align-items: stretch;
    grid-template-columns: 1fr;
    padding: 12px 14px;
  }
  .hn-disconnect-copy {
    grid-column: auto;
  }
  .hn-settings-feedback.is-error {
    align-items: stretch;
    flex-direction: column;
  }
}
@media (max-width: 390px) {
  .hn-settings-target small {
    display: none;
  }
  .hn-settings-target strong {
    margin-top: 0;
    max-width: 96px;
  }
  .hn-settings-tabs em {
    display: none;
  }
  .hn-settings-tabs a {
    grid-template-columns: 14px auto;
  }
  .hn-panel-head p {
    display: none;
  }
  .hn-disclosure summary > small,
  .hn-strategy-disclosure summary > small {
    display: none;
  }
  .hn-disclosure summary,
  .hn-strategy-disclosure summary {
    grid-template-columns: minmax(0, 1fr) 12px;
  }
  .hn-next-summary dd {
    font-size: 13px;
  }
  .hn-account-check__copy p {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .hn-settings-target,
  .hn-settings-tabs a,
  .hn-primary-button,
  .hn-secondary-button {
    transition: none;
  }
}`],
})
export class PageSettingsComponent implements OnInit, OnDestroy {
    public data: any = {
        target: null,
        kis_credentials_saved: false,
        kis: { product_code: '01' },
        kis_connection: { status: 'not_configured', checked_at: null, message: '' },
        minute_data: { status: 'not_configured', result: { stored_count: 0 } },
        strategy: {},
        strategy_context: { active_cycle: null, next_cycle: { parameters: {} } },
        live: { readiness: {} },
        shadow: {
            runtime: { state: 'NOT_STARTED' },
            strategy: { parameters: {}, budget: null, locked: true, live_order_enabled: false }
        }
    };
    public kisForm = new SettingsForms.KisFormState();
    public strategy = new SettingsForms.StrategyFormState();
    public savingKis = false;
    public checkingKis = false;
    public clearingKis = false;
    public savingStrategy = false;
    public preparingLive = false;
    public kisDirty = false;
    public editingKis = true;
    public confirmingKisDisconnect = false;
    public kisDisconnectPassword = '';
    public loading = true;
    public loadError = '';
    public fieldErrors: any = {};
    public pageNotice: any = null;
    public activeSection = 'kis';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.activeSection = this.sectionFromLocation('kis');
        await this.load();
    }

    public ngOnDestroy() {
        this.kisForm.reset();
        this.strategy.live_approval = '';
        this.strategy.strategy_current_password = '';
        this.kisDisconnectPassword = '';
    }

    @HostListener('window:beforeunload', ['$event'])
    public protectUnsavedChanges(event: BeforeUnloadEvent) {
        if (!this.hasUnsavedChanges) return;
        event.preventDefault();
        event.returnValue = '';
    }

    @HostListener('window:hashchange')
    public syncSectionFromLocation() {
        const section = this.sectionFromLocation(this.activeSection);
        if (section === this.activeSection) return;
        this.activeSection = section;
        void this.service.render();
    }

    public canDeactivate(): boolean {
        if (!this.hasUnsavedChanges) return true;
        return window.confirm('저장하지 않은 설정이 있습니다. 이 화면을 나갈까요?');
    }

    private sectionFromLocation(fallback: string) {
        const section = String(location.hash || '').replace(/^#/, '');
        return ['kis', 'strategy'].includes(section) ? section : fallback;
    }

    public async setActiveSection(section: string) {
        if (!['kis', 'strategy'].includes(section)) return;
        this.activeSection = section;
        await this.service.render();
    }

    private message(data: any, fallback: string) {
        return (data && data.message) || (typeof data === 'string' ? data : fallback);
    }

    public get strategyDirty() {
        return this.strategy.dirty;
    }

    public get liveBudgetChanged() {
        return this.strategy.liveBudgetChanged;
    }

    public get needsLiveApproval() {
        return this.liveBudgetChanged || !this.data.strategy?.live_approved;
    }

    public get hasUnsavedChanges() {
        const strategyConfirmationStarted = !!(
            this.strategy.live_approval
            || this.strategy.strategy_current_password
        );
        return (this.editingKis && this.kisDirty)
            || this.strategyDirty
            || strategyConfirmationStarted;
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        this.pageNotice = null;
        this.fieldErrors = {};
        await this.service.render();

        try {
            const { code, data } = await wiz.call('get');
            if (code !== 200 || !data) {
                throw new Error(this.message(data, '잠시 후 다시 시도해주세요.'));
            }
            this.data = data;
            this.resetKisEditor(!data.kis_credentials_saved);
            this.strategy.sync(data.strategy);
        } catch (error: any) {
            this.loadError = error?.message || '잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public clearFieldError(field: string) {
        if (this.fieldErrors[field]) delete this.fieldErrors[field];
        if (this.pageNotice?.type === 'error') this.pageNotice = null;
    }

    private async applyError(data: any, fallback: string) {
        const field = String(data?.field || '');
        const message = this.message(data, fallback);
        if (field) this.fieldErrors[field] = message;
        this.pageNotice = { type: 'error', message };
        await this.service.render();

        SettingsView.focusErrorField(field, '.hn-settings-notice');
    }

    private setSuccess(message: string) {
        this.fieldErrors = {};
        this.pageNotice = { type: 'success', message };
    }

    private resetKisEditor(editing: boolean) {
        this.kisForm.reset(this.data.kis?.product_code || '01');
        this.kisDirty = false;
        this.editingKis = editing;
        this.confirmingKisDisconnect = false;
        this.kisDisconnectPassword = '';
        this.fieldErrors = {};
    }

    public markKisDirty(field?: string) {
        this.kisDirty = true;
        if (field) this.clearFieldError(field);
    }

    public normalizeKisAccount() {
        this.kisForm.normalizeAccount();
        this.markKisDirty('account');
    }

    public toggleClearHtsId() {
        this.kisForm.clear_hts_id = !this.kisForm.clear_hts_id;
        if (this.kisForm.clear_hts_id) this.kisForm.hts_id = '';
        this.markKisDirty('hts_id');
        void this.service.render();
    }

    public async saveKis() {
        if (this.savingKis || this.checkingKis || this.clearingKis) return;
        const error = this.kisForm.validation(this.data.kis_credentials_saved);
        if (error) {
            await this.applyError(error, error.message);
            return;
        }

        this.savingKis = true;
        this.pageNotice = null;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save_kis', this.kisForm.payload());
            if (code !== 200) {
                await this.applyError(data, 'KIS 정보를 저장하지 못했습니다.');
                return;
            }
            this.data = data;
            this.resetKisEditor(false);
            this.setSuccess(
                data.kis_connection?.status === 'connected'
                    ? 'KIS 정보를 저장했습니다.'
                    : 'KIS 정보를 저장했습니다. 연결 확인을 진행해주세요.'
            );
        } catch (error) {
            await this.applyError(null, 'KIS 정보 저장 요청을 완료하지 못했습니다.');
        } finally {
            this.savingKis = false;
            await this.service.render();
        }
    }

    public async beginKisEdit() {
        if (this.savingKis || this.checkingKis || this.clearingKis) return;
        this.resetKisEditor(true);
        this.pageNotice = null;
        await this.service.render();
        setTimeout(() => document.getElementById('hn-kis-app-key')?.focus(), 20);
    }

    public async cancelKisEdit() {
        if (this.savingKis) return;
        if (this.kisDirty) {
            const confirmed = await this.service.modal.warning(
                '입력한 KIS 변경 내용을 버릴까요?',
                '계속 편집',
                '변경 취소'
            );
            if (!confirmed) return;
        }
        this.resetKisEditor(false);
        await this.service.render();
        setTimeout(() => document.getElementById('hn-kis-edit')?.focus(), 20);
    }

    public async beginKisDisconnect() {
        this.confirmingKisDisconnect = true;
        this.kisDisconnectPassword = '';
        this.clearFieldError('kis_disconnect_password');
        await this.service.render();
        setTimeout(() => document.getElementById('hn-kis-disconnect-password')?.focus(), 20);
    }

    public async cancelKisDisconnect() {
        this.confirmingKisDisconnect = false;
        this.kisDisconnectPassword = '';
        this.clearFieldError('kis_disconnect_password');
        await this.service.render();
    }

    public async clearKis() {
        if (this.clearingKis || !this.data.kis_credentials_saved) return;
        if (!this.kisDisconnectPassword) {
            await this.applyError(
                { field: 'kis_disconnect_password', message: '현재 비밀번호를 입력해주세요.' },
                '현재 비밀번호를 입력해주세요.'
            );
            return;
        }
        const confirmed = await this.service.modal.warning(
            '저장된 App Key, App Secret, 계좌번호와 HTS ID를 모두 삭제할까요? 자동 주문 준비 상태도 해제됩니다.',
            '취소',
            'KIS 연결 해제'
        );
        if (!confirmed) return;

        this.clearingKis = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('clear_kis', {
                kis_disconnect_password: this.kisDisconnectPassword
            });
            if (code !== 200) {
                await this.applyError(data, 'KIS 연결을 해제하지 못했습니다.');
                return;
            }
            this.data = data;
            this.resetKisEditor(true);
            this.setSuccess('KIS 연결 정보와 자동 주문 준비 상태를 삭제했습니다.');
        } catch (error) {
            await this.applyError(null, 'KIS 연결 해제 요청을 완료하지 못했습니다.');
        } finally {
            this.clearingKis = false;
            await this.service.render();
        }
    }

    public get kisConnectionStatus() {
        return SettingsView.connectionStatus(this.data, this.checkingKis, this.kisDirty);
    }

    public get kisConnectionLabel() {
        return SettingsView.connectionLabel(this.kisConnectionStatus);
    }

    public get canVerifyKis() {
        return !!this.data.kis_credentials_saved
            && !this.editingKis
            && !this.kisDirty
            && !this.savingKis
            && !this.checkingKis
            && !this.clearingKis;
    }

    public get kisProductLabel() {
        return SettingsView.productLabel(this.data.kis?.product_code);
    }

    public get minuteDataStatus() {
        return SettingsView.minuteStatus(this.data);
    }

    public get minuteDataLabel() {
        return SettingsView.minuteLabel(this.data);
    }

    public get minuteDataDetail() {
        return SettingsView.minuteDetail(this.data);
    }

    public get minuteDataLatest() {
        return SettingsView.minuteLatest(this.data);
    }

    public get activeCycleStrategy() {
        return this.data.strategy_context?.active_cycle || null;
    }

    public get nextCycleStrategy() {
        return this.data.strategy_context?.next_cycle || { parameters: {} };
    }

    public get nextParameters() {
        return this.nextCycleStrategy.parameters || {};
    }

    public get buyAllocationPreview() { return SettingsView.buyAllocationPreview(this.data, this.strategyDirty); }

    public get automaticBudget() {
        return SettingsView.automaticBudget(this.data);
    }

    public get nextLiveCommittedLimit() {
        const pct = Number(this.nextParameters.max_committed_pct || 0);
        const budget = this.strategy.budget_mode === 'AUTO'
            ? this.automaticBudget : Number(this.strategy.live_budget || 0);
        return Math.floor(budget * pct / 100);
    }

    public readonly formatMoney = SettingsView.formatMoney;
    public readonly formatCheckedAt = SettingsView.formatCheckedAt;
    public readonly strategyVersionLabel = SettingsView.versionLabel;
    public readonly executionModeLabel = SettingsView.executionModeLabel;
    public readonly percentPlan = SettingsView.percentPlan;
    public readonly quantityPlan = SettingsView.percentPlan;
    public positivePercentPlan(values: any) {
        return SettingsView.percentPlan(values, '+');
    }

    public async verifyKis() {
        if (!this.canVerifyKis) return;
        this.checkingKis = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('verify_kis', {});
            if (data?.connection) this.data.kis_connection = data.connection;
            if (code !== 200) {
                await this.service.modal.error(
                    this.message(data, this.data.kis_connection?.message || 'KIS 연결을 확인하지 못했습니다.')
                );
            }
        } catch (error) {
            await this.service.modal.error('KIS 연결 확인 요청을 완료하지 못했습니다.');
        } finally {
            this.checkingKis = false;
            await this.service.render();
        }
    }

    public onStrategyChange(field: string) {
        this.clearFieldError(field);
        if (field === 'budget_mode' || field === 'live_budget') {
            this.strategy.live_approval = '';
            this.strategy.strategy_current_password = '';
            this.clearFieldError('live_approval');
            this.clearFieldError('strategy_current_password');
        }
        void this.service.render();
    }

    private async validateStrategy() {
        const error = this.strategy.validation(this.needsLiveApproval);
        if (!error) return true;
        await this.applyError(error, error.message);
        return false;
    }

    public async saveStrategy() {
        if (this.savingStrategy) return;
        const approvalRequired = this.needsLiveApproval;
        if (!(await this.validateStrategy())) return;
        this.savingStrategy = true;
        this.pageNotice = null;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('save_strategy', this.strategy.payload());
            if (code === 401) {
                await this.applyError(
                    null,
                    '로그인이 만료되었습니다. 다시 로그인해주세요.'
                );
                return;
            }
            const savedStrategy = data?.strategy
                || (data?.total_budget !== undefined ? data : null);
            if (code !== 200 || !savedStrategy) {
                await this.applyError(data, '운용 설정을 저장하지 못했습니다.');
                return;
            }
            if (data?.settings) {
                this.data = data.settings;
            } else {
                const refreshed: any = await wiz.call('get');
                this.data = refreshed?.code === 200 && refreshed?.data
                    ? refreshed.data
                    : {
                        ...this.data,
                        strategy: savedStrategy,
                        live: {
                            ...(this.data.live || {}),
                            preflight: null,
                            readiness: {
                                ...(this.data.live?.readiness || {}),
                                account: false,
                                ready: false
                            }
                        }
                    };
            }
            this.strategy.sync(this.data.strategy || savedStrategy);
            if (approvalRequired && !this.data.strategy?.live_approved) {
                const message = '운용 승인이 반영되지 않았습니다. 다시 승인해주세요.';
                await this.applyError({ field: 'live_approval', message }, message);
                return;
            }
            this.setSuccess('운용 설정을 저장했습니다. 안전 기준은 즉시 적용됩니다.');
        } catch (error) {
            await this.applyError(null, '운용 설정 저장 요청을 완료하지 못했습니다.');
        } finally {
            this.savingStrategy = false;
            await this.service.render();
        }
    }

    public get liveReadiness() { return this.data.live?.readiness || {}; }
    public get liveAccountReady() { return this.liveReadiness.account === true; }

    public get liveSettlementPending() { return this.data.live?.preflight?.settlement_pending === true; }

    public get livePrerequisites() {
        return SettingsView.livePrerequisites(this.data, this.liveAccountReady);
    }

    public get canPrepareLive() {
        const inputsReady = this.livePrerequisites
            .filter((item: any) => item.key !== 'account')
            .every((item: any) => item.ready);
        return inputsReady && !this.strategyDirty && !this.preparingLive;
    }

    public get livePrepareBlocker() {
        if (this.strategyDirty) return '운용 설정을 먼저 저장해주세요.';
        const missing = this.livePrerequisites
            .filter((item: any) => item.key !== 'account' && !item.ready)
            .map((item: any) => item.label);
        return missing.length ? `먼저 준비할 항목: ${missing.join(', ')}` : '';
    }

    public async prepareLive() {
        if (!this.canPrepareLive) {
            await this.applyError(
                null,
                this.livePrepareBlocker || '계좌 확인을 준비하지 못했습니다.'
            );
            return;
        }
        const confirmed = await this.service.modal.warning(
            'KIS 잔고와 주문가능금액을 확인해 실전 주문 준비 상태를 만들까요? 주문은 보내지 않습니다.',
            '취소',
            '준비 확인'
        );
        if (!confirmed) return;

        this.preparingLive = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('prepare_live', {});
            if (code !== 200) {
                await this.applyError(data, '계좌 준비를 확인하지 못했습니다.');
                return;
            }
            if (data?.settings) {
                const kisHints = this.data.kis;
                this.data = { ...data.settings, kis: kisHints };
                this.strategy.sync(data.settings.strategy || this.strategy);
            }
            const running = this.data.execution_control?.control_mode === 'RUNNING';
            const message = this.liveSettlementPending
                ? '계좌를 확인했습니다. 결제 중 금액은 주문 가능 금액에 반영됩니다.'
                : running ? '계좌를 확인했습니다. 자동매수는 계속 실행됩니다.'
                    : '계좌를 확인했습니다. 자동매수는 중지 상태입니다.';
            this.setSuccess(message);
        } catch (error) {
            await this.applyError(null, '계좌 준비 확인 요청을 완료하지 못했습니다.');
        } finally {
            this.preparingLive = false;
            await this.service.render();
        }
    }
}

export default PageSettingsComponent;